import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

import { BaseResponseSingle } from "../../typings/interfaces";
import {
  ICustomerRefundStatisticsResponse,
  ICustomerRefundHistoryResponse,
} from "../../typings/interfaces/responses";
import {
  GET_CUSTOMER_REFUND_STATS,
  GET_CUSTOMER_REFUND_STATS_BY_YEAR,
  GET_CUSTOMER_REFUND_HISTORY,
} from "../../configs/apiConfig";

export const getCustomerRefundStatsAction = createAsyncThunk(
  "customer/refundStats",
  async (customerId: number, { rejectWithValue }) => {
    try {
      const response = await axios.get<
        BaseResponseSingle<ICustomerRefundStatisticsResponse>
      >(GET_CUSTOMER_REFUND_STATS(customerId));
      return response.data;
    } catch (err: any) {
      if (!err.response) throw err;
      return rejectWithValue(err.response.data);
    }
  }
);

export const getCustomerRefundStatsByYearAction = createAsyncThunk(
  "customer/refundStatsByYear",
  async (
    { customerId, year }: { customerId: number; year: number },
    { rejectWithValue }
  ) => {
    try {
      const response = await axios.get<
        BaseResponseSingle<ICustomerRefundStatisticsResponse>
      >(GET_CUSTOMER_REFUND_STATS_BY_YEAR(customerId, year));
      return response.data;
    } catch (err: any) {
      if (!err.response) throw err;
      return rejectWithValue(err.response.data);
    }
  }
);

export const getCustomerRefundHistoryAction = createAsyncThunk(
  "customer/refundHistory",
  async (customerId: number, { rejectWithValue }) => {
    try {
      const response = await axios.get<
        BaseResponseSingle<ICustomerRefundHistoryResponse>
      >(GET_CUSTOMER_REFUND_HISTORY(customerId));
      return response.data;
    } catch (err: any) {
      if (!err.response) throw err;
      return rejectWithValue(err.response.data);
    }
  }
);
